import React, { FC } from "react";

import { ActionButton } from "../TopBar/ActionButton";
import { NoResource } from "./NoResource";

interface NoProjectsProps {
  headerText: string;
}

export const NoProjects: FC<NoProjectsProps> = ({ headerText }) => (
  <NoResource headerText={headerText}>
    <ActionButton />
  </NoResource>
);
